import { render, staticRenderFns } from "./ExtraCreditZoneReportList.vue?vue&type=template&id=a2040706&scoped=true"
import script from "./ExtraCreditZoneReportList.vue?vue&type=script&lang=js"
export * from "./ExtraCreditZoneReportList.vue?vue&type=script&lang=js"
import style0 from "./ExtraCreditZoneReportList.vue?vue&type=style&index=0&id=a2040706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2040706",
  null
  
)

export default component.exports